/* eslint no-useless-escape: 0 */

const proto = "Audio taken from \"The Amazing World of Psychic Phenomena\" (1976) - Edgar Mitchell - Apollo XIV Astronaut"

export default proto;